export const OpcionesEstadosTratamientos = [
    { value: '', label: '-- Selecciona una opción --', disabled: true },
    { value: 'seguimiento', label: 'En seguimiento' },
    { value: 'fin-con-consumo', label: 'Finaliza con consumo' },
    { value: 'fin-sin-consumo', label: 'Finaliza sin consumo' },
    { value: 'alta-sin-consumo', label: 'Alta anticipada sin consumo' },
    { value: 'alta-con-consumo', label: 'Alta anticipada con consumo' },
    { value: 'aband-mala-evol', label: 'Abandona con mala evolución' },
    { value: 'aband-buena-evol', label: 'Abandona con buena evolución' },
    { value: 'recaida-otro-centro', label: 'Recaída, fue a otro centro' },
    { value: 'recaida-tavad', label: 'Recaída, reingresó en TAVAD' },
    { value: 'recaida-no-volvio', label: 'Recaída, no volvió al tratamiento' },
    { value: 'no-se-sabe', label: 'No se sabe nada del paciente' },
    { value: 'defuncion', label: 'Defunción' },
    { value: 'carcel', label: 'Cárcel' },
    { value: 'enf-grave', label: 'Enfermedad grave' },
    { value: 'ning-sesion', label: 'No realizó ninguna sesión' },
    { value: 'sin-seguimiento', label: 'Sin seguimiento' }
  ];